// extracted by mini-css-extract-plugin
module.exports = {"pillGroup":"AspectFilter_pillGroup__3cjcg"};